import { useGetCustomerApi } from './api/customer/useGetCustomer.api';
import { useGetPersonApi } from './api/user/useGetPerson.api';
import { useGetFamilyApi } from './api/family/useGetFamily.api';
import { useCallback, useMemo } from 'react';
import { getFamilySchedulesUtils } from '../utils';
import { useNotificationsMessage } from '../contexts';
import { FamilyRole } from '../models';
import { useLanguage } from '../locale';
export var useRecurrentAbsencesHook = function () {
    var t = useLanguage()[0];
    var showNotifications = useNotificationsMessage().showNotifications;
    var customer = useGetCustomerApi(true).data;
    var person = useGetPersonApi(customer === null || customer === void 0 ? void 0 : customer.personId).data;
    var family = useGetFamilyApi(person === null || person === void 0 ? void 0 : person.familyId, !!(customer === null || customer === void 0 ? void 0 : customer.personId)).data;
    var familyRecurrences = useMemo(function () { return (family ? getFamilySchedulesUtils(family) : []); }, [family]);
    var onEditSchedulePress = useCallback(function (callback) {
        if ((person === null || person === void 0 ? void 0 : person.familyRole) !== FamilyRole.FAMILY_LEADER) {
            return showNotifications({
                text: t('profile.plan.recurrences.onlyLeaderCanManage'),
                isError: true,
            });
        }
        callback();
    }, [person === null || person === void 0 ? void 0 : person.familyRole, showNotifications, t]);
    return {
        familyRecurrences: familyRecurrences,
        onEditSchedulePress: onEditSchedulePress,
    };
};
